import { render } from "./CreateParker.vue?vue&type=template&id=1234f0ef&scoped=true"
import script from "./CreateParker.vue?vue&type=script&lang=js"
export * from "./CreateParker.vue?vue&type=script&lang=js"

import "./CreateParker.vue?vue&type=style&index=0&id=1234f0ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1234f0ef"]])

export default __exports__